import { Currency } from '@/core/currency/interfaces';

const GEL: Currency = {
    name: 'Georgian Lari',
    demonym: 'Georgian',
    majorSingle: 'Lari',
    majorPlural: 'Lari',
    codeNumeric: '981',
    symbol: '₾',
    symbolNative: '₾',
    minorSingle: 'Tetri',
    minorPlural: 'Tetri',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GEL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GEL;
